<template>
  <div class="hidden xl:block self-start sticky top-14 h-[calc(100vh-3.5rem)]">
    <button
      type="button"
      class="absolute z-30 top-20 -left-3 -translate-y-1/2 flex h-6 w-6 items-center justify-center rounded-full border border-untitled-gray-200 bg-white text-untitled-gray-400 shadow-sm ring-1 ring-black/5 transition-all duration-200 hover:scale-110 hover:border-app-primary hover:text-app-primary hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-app-primary focus-visible:ring-offset-1"
      :aria-label="rightPanelVisible ? 'Hide side panel' : 'Show side panel'"
      :aria-expanded="rightPanelVisible"
      :class="{
        '-left-6': !rightPanelVisible,
      }"
      @click="layoutStore.toggleRightPanel"
    >
      <ChevronRightIcon v-if="rightPanelVisible" class="w-3.5 h-3.5" />
      <ChevronLeftIcon v-else class="w-3.5 h-3.5" />
    </button>

    <aside
      class="h-full bg-white border-l border-untitled-gray-200 overflow-hidden transition-all duration-300"
      :class="rightPanelVisible ? 'w-[320px] 2xl:w-[420px] 4xl:w-[550px]' : 'w-0 border-l-0'"
    >
      <div class="w-[320px] 2xl:w-[420px] 4xl:w-[550px] h-full flex flex-col">
        <UserDisplay />

        <div class="flex-1 flex flex-col overflow-hidden pt-5 min-h-0">
          <div
            v-if="false"
            class="flex items-center border-b border-untitled-gray-200 shrink-0"
          >
            <button
              v-for="tab in tabs"
              :key="tab.name"
              type="button"
              class="relative flex-1 pb-3 text-sm font-medium transition-colors"
              :class="
                activeTab === tab.name
                  ? 'text-emerald-700'
                  : 'text-untitled-gray-500 hover:text-untitled-gray-700'
              "
              @click="activeTab = tab.name"
            >
              {{ tab.label }}
              <span
                v-if="activeTab === tab.name"
                class="absolute left-0 -bottom-px h-0.5 w-full bg-emerald-700 rounded-full"
              />
            </button>
          </div>

          <div class="flex-1 overflow-y-auto px-4 min-h-0">
            <div v-show="activeTab === 'reminders'" class="flex flex-col gap-3">
              <V4ReminderList />
            </div>
            <div v-show="activeTab === 'events'" class="flex flex-col gap-3">
              <V4EventList />
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/outline";
import { useLayoutStore } from "@/stores/useLayoutStore";
import { storeToRefs } from "pinia";
import V4ReminderList from "@/components/v4/home/V4ReminderList.vue";
import V4EventList from "@/components/v4/home/V4EventList.vue";
import UserDisplay from "./UserDisplay.vue";

const layoutStore = useLayoutStore();

const { rightPanelVisible } = storeToRefs(layoutStore);

const tabs = [
  // { name: "reminders", label: "Reminders" },
  { name: "events", label: "Events" },
];
const activeTab = ref("events");
</script>

<style scoped>
.switch-as-role {
  --el-switch-on-color: #047857;
}
</style>
